<script>
  import api from './api.js';
  import KeyHandler from './components/KeyHandler.svelte';

  let apps = [];
  let selected = -1;

  const load = async () => {
    apps = await api.GET('/apps');
  }

  const setSelected = n => {
    console.log('setSelected', n, apps.length);
    if (n < 0) n = 0;
    if (n > apps.length-1) n = apps.length -1;
    selected = n;
  }

  const nav = (appName) => {
    if (!appName) {
      if (selected === -1) return;
      appName = apps?.[selected].name;
    }
    window.location.href = `?app=${appName}`;
  }

  const keyHandlers = {
    'ArrowDown': () => setSelected(selected+1),
    'ArrowUp': () => setSelected(selected-1),
    'PageDown': () => setSelected(selected+10),
    'PageUp': () => setSelected(selected-10),
    'Enter': nav,
    'Space': nav,
	};

  load();
</script>

<KeyHandler handlers={keyHandlers} />
<div>
  {#each apps as x, i}
    <h1 class:selected={selected==i} on:click={nav(x.name)}>{x.name}</h1>
  {/each}
</div>

<style>
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  h1 {
    margin-top: 0;
    opacity: 0.6;
    transition: all 100ms ease-in-out;
  }
  h1:hover {
    color: #ff3f99;
    cursor: pointer;
  }
  .selected {
    color: #ff3f99;
  }
</style>
